function ChevronRight() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="white" />
      <path
        d="M16.3431 23.6066C16.7337 23.9971 17.3668 23.9971 17.7574 23.6066L22.7071 18.6569C23.0976 18.2663 23.0976 17.6332 22.7071 17.2426L17.7574 12.2929C17.3668 11.9024 16.7337 11.9024 16.3431 12.2929C15.9526 12.6834 15.9526 13.3166 16.3431 13.7071L20.5858 17.9498L16.3431 22.1924C15.9526 22.5829 15.9526 23.2161 16.3431 23.6066Z"
        fill="#323232"
      />
    </svg>
  );
}

export default ChevronRight;
